import { render, staticRenderFns } from "./TopArtifactsTable.vue?vue&type=template&id=944e662e&scoped=true&"
import script from "./TopArtifactsTable.vue?vue&type=script&lang=js&"
export * from "./TopArtifactsTable.vue?vue&type=script&lang=js&"
import style0 from "./TopArtifactsTable.vue?vue&type=style&index=0&id=944e662e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944e662e",
  null
  
)

export default component.exports